import React, { useState, useEffect } from "react";
import "./NavBarStyles.css";

const NavBar = ({ onNavigate }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isNavigating, setIsNavigating] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (sectionName) => {
    setIsNavigating(true);
    onNavigate(sectionName);
    setIsMenuOpen(false);
    
    // Reset navigating state after navigation completes
    setTimeout(() => {
      setIsNavigating(false);
    }, 1000);
  };

  return (
    <nav className={`navbar ${isScrolled || isNavigating ? 'scrolled' : ''}`}>
      <div className="nav-container">
        {/* Logo minimalista */}
        <div className="nav-logo" onClick={() => handleNavClick('hero')}>
          <div className="logo-dot"></div>
          <span className="logo-text">MB</span>
        </div>

        {/* Navegación principal */}
        <div className={`nav-links ${isMenuOpen ? 'active' : ''}`}>
          <button 
            className="nav-item" 
            onClick={() => handleNavClick('projects')}
          >
            <span className="nav-number">01</span>
            <span className="nav-label">Projects</span>
          </button>
          
          <button 
            className="nav-item" 
            onClick={() => handleNavClick('about')}
          >
            <span className="nav-number">02</span>
            <span className="nav-label">About</span>
          </button>
          
          <button 
            className="nav-item" 
            onClick={() => handleNavClick('experience')}
          >
            <span className="nav-number">03</span>
            <span className="nav-label">Experience</span>
          </button>
          
          <button 
            className="nav-item" 
            onClick={() => handleNavClick('contact')}
          >
            <span className="nav-number">04</span>
            <span className="nav-label">Contact</span>
          </button>
        </div>

        {/* Botón de menú móvil */}
        <button 
          className={`menu-toggle ${isMenuOpen ? 'active' : ''}`}
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          <span className="menu-line"></span>
          <span className="menu-line"></span>
        </button>
      </div>
    </nav>
  );
};

export default NavBar;
